import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionHeading from '@/components/feature/SectionHeading';

const accentRing: Record<string, string> = {
  primary: 'text-primary-600 bg-primary-50 border-primary-200',
  accent: 'text-accent-700 bg-accent-50 border-accent-200',
  secondary: 'text-secondary-800 bg-secondary-50 border-secondary-200',
};

const accentBar: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function TopicGrid() {
  return (
    <section id="topics" className="w-full bg-background-100 py-12 md:py-16 scroll-mt-32">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="主题分类"
          title="六大栏目，按兴趣挑着看"
          description="每个栏目独立维护更新节奏，你可以只看自己关心的方向，也可以按分类回看历史事件。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative block rounded-lg overflow-hidden border border-background-200 bg-background-50 cursor-pointer"
            >
              <div className="w-full h-40 md:h-44">
                <img
                  src={cat.cover}
                  alt={`${cat.name}栏目配图 · 17c吃瓜`}
                  title={`${cat.name} · ${cat.description}`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
              </div>
              <span className={`absolute top-3 left-3 w-9 h-9 flex items-center justify-center rounded-md border backdrop-blur-sm ${accentRing[cat.accent]}`}>
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <div className="flex items-center gap-2">
                  <span className={`w-1.5 h-4 rounded-full ${accentBar[cat.accent]}`}></span>
                  <h3 className="font-heading text-lg font-bold text-background-50">{cat.name}</h3>
                  <span className="text-[11px] text-background-200">{cat.count} 篇</span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{cat.description}</p>
                <div className="mt-3 flex flex-wrap items-center gap-1.5">
                  {cat.keywords.map((kw) => (
                    <span
                      key={kw}
                      className="px-2 py-0.5 text-[11px] rounded-full bg-background-100 text-foreground-600"
                    >
                      {kw}
                    </span>
                  ))}
                </div>
                <div className="mt-3 pt-3 border-t border-background-100 flex items-center justify-between text-xs text-foreground-500">
                  <span>更新于 {cat.updatedAt}</span>
                  <span className="text-primary-600 group-hover:translate-x-0.5 transition-transform">
                    进入栏目 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}